export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus["NEW"] = "NEW";
    LicenseStatus["VALIDATED"] = "VALIDATED";
    LicenseStatus["SCORED"] = "SCORED";
    LicenseStatus["CERTIFICATION_FAILED"] = "CERTIFICATION_FAILED";
    LicenseStatus["CERTIFICATION_REVOKED"] = "CERTIFICATION_REVOKED";
    LicenseStatus["APPEALED"] = "APPEALED";
    LicenseStatus["CERTIFIED"] = "CERTIFIED";
    LicenseStatus["SPEAKING_UNSCORBALE"] = "SPEAKING_UNSCORBALE";
    LicenseStatus["LATE_HANGUP"] = "LATE_HANGUP";
    LicenseStatus["USER_HUNG_UP"] = "USER_HUNG_UP";
    LicenseStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LicenseStatus["STARTED"] = "STARTED";
    LicenseStatus["ERROR"] = "ERROR";
    LicenseStatus["NOT_SCORABLE"] = "NOT_SCORABLE";
    LicenseStatus["PARTIALLY_SCORED"] = "PARTIALLY_SCORED";
    LicenseStatus["COMPLETED"] = "COMPLETED";
    LicenseStatus["UPLOADING"] = "UPLOADING";
    LicenseStatus["ABORTED"] = "ABORTED";
})(LicenseStatus || (LicenseStatus = {}));
export const statusesWithDetailsPage = [LicenseStatus.CERTIFIED];
export const statusesWithoutNewAndValidated = [
    LicenseStatus.STARTED,
    LicenseStatus.COMPLETED,
    LicenseStatus.LATE_HANGUP,
    LicenseStatus.USER_HUNG_UP,
    LicenseStatus.ERROR,
    LicenseStatus.NOT_SCORABLE,
    LicenseStatus.PARTIALLY_SCORED,
    LicenseStatus.SCORED,
    LicenseStatus.CERTIFICATION_FAILED,
    LicenseStatus.CERTIFICATION_REVOKED,
    LicenseStatus.CERTIFIED,
    LicenseStatus.ABORTED
];
//# sourceMappingURL=licenses.interfaces.js.map